<div class="container">
  <div class="title">
    <h3>Destaque</h3>
  </div>
  <div class="items-wrapper">
    <swiper-container #swiperEl class="items" init="false">
      <swiper-slide class="item" *ngFor="let item of items" (click)="itemClick.emit(item)">
        <mnt-badge class="featured-badge" *ngIf="item.featured?.featured_type === 'MOST_ORDERS'"
          label="Mais pedido" color="success" tone="highlight" size="tiny"></mnt-badge>
        <mnt-badge class="featured-badge" *ngIf="item.featured?.featured_type === 'OFFER'"
          label="Oferta" color="warning" tone="highlight" size="tiny"></mnt-badge>
        <mnt-badge class="featured-badge" *ngIf="item.featured?.featured_type === 'ONLY_TODAY'"
          label="Só hoje" color="critical" tone="highlight" size="tiny"></mnt-badge>
        <mnt-badge class="featured-badge" *ngIf="item.featured?.featured_type === 'NEW'"
          label="Novidade" color="primary" tone="highlight" size="tiny"></mnt-badge>
        <img
          [src]="item.img || 'https://cdn-production.yooga.com.br/120201112170357YBpu1ClGH.png'"
          [alt]="item.name"
        />
        <div class="item-info">
          <h4>{{ item.name }}</h4>
          <div class="item-price">
            <span class="item-price-value">
              {{ (item.promotional_price || item.price) | currency }}
            </span>
            <span class="item-price-old" *ngIf="item.promotional_price">
              {{ item.price | currency }}
            </span>
            <mnt-badge
              *ngIf="item.promotional_percentage"
              [label]="item.promotional_percentage + '%'"
              color="primary"
              variant="regular"
              size="tiny"
              tone="highlight"
            ></mnt-badge>
          </div>
        </div>
      </swiper-slide>
    </swiper-container>
  </div>
</div>
